export const toMoney = (value) => {
  const numberValue = Number(value);

  if (isNaN(numberValue)) {
    return "";
  }

  return numberValue.toLocaleString();
};
